export class Orden{
    id:number;
    creationDate:Date;
    estado:number;
    tipo:number;  
    idTRXPasarela:number;  
    seguro:number
    valor_orden:number;
}
